import React, { useCallback } from 'react'
import { Button } from 'antd'
import { withRouter } from 'react-router-dom'
import { IOT_STATUS } from '@/constants'
import style from './Index.module.less'

const getStatus = (status) => {
  if (status === IOT_STATUS.NOT_START) {
    return '未开始'
  }
  if (status === IOT_STATUS.ING) {
    return '进行中'
  }
  return '已结束'
}

const Index = ({ history, it }) => {
  const handleJumpDetailPage = useCallback(
    (item) => {
      history.push(`/IoT/${item.id}`)
    },
    [history]
  )

  return (
    <div onClick={() => handleJumpDetailPage(it)} styleName="item">
      <div
        className={`${style.status} ${
          it.status === IOT_STATUS.ING ? style.new : style.finish
        }`}
      >
        {getStatus(it.status)}
      </div>
      <img src={it.cover} styleName="image" />
      <div styleName="box">
        <div styleName="title">{it.name}</div>
        <div styleName="time">{`活动开始时间：${it.startAt}`}</div>
        <div styleName="info">{`任务描述：${it.description}`}</div>
      </div>
      <div styleName="card">
        <div styleName="card__name">{it.name}</div>
        <Button type="primary" styleName="card__button">
          查看详情
        </Button>
      </div>
    </div>
  )
}

export default withRouter(Index)
